import moment from 'moment'

export default (date, days) => moment(date, "DD-MM-YYYY").add(days, 'days');